import hhkjsq from '@/common/hhkjsq.js'
import $ from 'zepto'
import {Toast} from 'mint-ui'

const {app, hosts, appInfo} = hhkjsq
export const toast = function (msg) {
  Toast({
    message: msg,
    position: 'bottom',
    duration: 2000,
    className: 'm-toast'
  })
}

export const setWebShare = function (shareInfo) {
  app.appWebShare({
    isShow: true,
    title: shareInfo.title,
    describe: shareInfo.content,
    shareImg: shareInfo.imageUrl,
    link: shareInfo.titleUrl
  })
}

export const sharePage = function (shareInfo) {
  app.shareWebPage(shareInfo)
}

export const setPageTitle = function (title) {
  document.title = title
}

export const imgStr2Arr = function (imgStr) {
  var arr = imgStr.split('|')
  var imgArr = []
  for (var i = 0, len = arr.length; i < len; i++) {
    var temp = arr[i].split(',')
    var o = {
      id: temp[0],
      src: hosts.showimg + temp[1],
      index: temp[2],
      size: temp[3]
    }
    imgArr.push(o)
  }
  return imgArr
}

export const queryString = function (k, s) {
  /* eslint-disable no-useless-escape */
  var r, t
  s = s || '?'
  k = k.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]')
  r = new RegExp('[\\' + s + '&]' + k + '=([^&#]*)')
  t = r.exec(window.location.href)
  return (t == null) ? '' : t[1]
}

// 用Promise改造$.ajax，向外暴露fetch方法
export const fetch = function (options) {
  return function () {
    return new Promise(function (resolve, reject) {
      $.ajax({
        url: options.url,
        data: options.data || {},
        type: options.type || 'GET',
        dataType: options.dataType || 'none',
        callback: options.callback || 'callback',
        timeout: 5000,
        success: resolve,
        error: reject,
        headers: {
          'Access-Token': app.getToken() || ''
        }
      })
    })
  }
}

// 用Promise改造app.ajax方法
export const fetchAjax = function (options) {
  return function () {
    return new Promise(function (resolve, reject) {
      app.ajax({
        url: options.url,
        params: options.data || {},
        type: options.type || 'GET',
        dataType: options.dataType || 'json',
        success: resolve,
        error: reject
      })
    })
  }
}

export const inOtherBroswer = function () {
  if (appInfo) {
    return false
  }
  const scheme = 'WebPage?url=' + window.location.href
  window.location.href = hosts.main + '/ZT/wap/openapp/index.html?scheme=' + encodeURIComponent(scheme) + '&pagename=live&frompage108sq=fromwx'
  return true
}

export const isLogin = function () {
  if (app.getToken()) {
    return true
  }
  app.toLogin(true)
  return false
}

export const statistics = function (eventName, postId) {
  app.webStatistics({
    pageName: 'Teletext',
    eventName: eventName,
    SiteId: appInfo ? appInfo.cityId : 0,
    TeletextId: queryString('id'),
    PostId: postId || 0
  })
}

export function scrollTop (el, from = 0, to, duration = 500, cb = function () {}) {
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = (
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function (callback) {
        return window.setTimeout(callback, 1000 / 60)
      }
    )
  }
  const difference = Math.abs(from - to)
  const step = Math.ceil(difference / duration * 50)

  function scroll (start, end, step, cb) {
    if (start === end) {
      cb()
      return
    }

    let d = (start + step > end) ? end : start + step
    if (start > end) {
      d = (start - step < end) ? end : start - step
    }

    if (el === window) {
      window.scrollTo(d, d)
    } else {
      el.scrollTop = d
    }
    window.requestAnimationFrame(() => scroll(d, end, step, cb))
  }
  scroll(from, to, step, cb)
}

export const canvasSupported = (function () {
  return !!document.createElement('canvas').getContext
})()

export const isObjectFitCompatible = (function () {
  const sty = document.createElement('div').style
  return ('objectFit' in sty)
})()



// WEBPACK FOOTER //
// ./src/utils/index.js